import md5 from 'md5';
// import { SUBTYPE_PASSPORT } from '../../utils/constants';

export function checkDuplicates(fileNames) {
  return new Set(fileNames).size !== fileNames.length;
}

// export const checkFileNameDuplicates = values => {
//   const frontSideName = values.idDocument[0].name;
//   const proofOfAddressName = values.proofOfAddress[0].name;

//   if (values.typeOfDocument === SUBTYPE_PASSPORT) {
//     return checkDuplicates([frontSideName, proofOfAddressName]);
//   }

//   const backSideName = values.idDocument[1].name;
//   return checkDuplicates([frontSideName, backSideName, proofOfAddressName]);
// };

export const blobToFile = (blob, fileName) => {
  // A Blob() is almost a File() - it's just missing the two properties below which we will add
  blob.lastModifiedDate = new Date();
  blob.lastModified = new Date().getTime();
  blob.name = fileName;
  return blob;
};

export const toKB = size => Math.round(size / 1024);

export const decorateWithId = file => {
  const decoratedFile = file;
  decoratedFile.id = md5(file.name + file.lastModified);
  return decoratedFile;
};

export const sameNamesCheck = (acceptedFile, currentFiles) => {
  const result = currentFiles.filter(item => item.name === acceptedFile.name);
  return result.length;
};

/**
 * Removes dupliciet properties if have duplicit values
 * @param {object} obj
 * @author jozef.repan
 */
export const removeDuplicateValues = obj => {
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    for (let j = i + 1; j < keys.length; j++) {
      if (obj[keys[i]] === obj[keys[j]]) {
        obj[keys[i]] = undefined;
        break;
      }
    }
  }
};
